import React, { useEffect, useState } from "react";
import { Button, Modal, Table } from "antd";
import ButtonRow from "../common/ButtonRow";
import { getRopeLogEntries } from "../../api/ropeApi";
import { ConvertRopeLogData } from "../../utils/convert";
import displayErrorNotification from "../../utils/displayErrorNotification";
import { RopeLog } from "../../types/Rope";
import { ColumnProps } from "antd/lib/table";
import { formatDateTime } from "../../utils/formatDateTime";
import { Link } from "react-router-dom";
import { textOverflow } from "../common/textOverflow";
import RopeViewLogRecordModal from "./RopeViewLogRecordModal";

type RopeViewLogModalProps = {
  modalState: boolean;
  closeModal: () => void;
};

const RopeViewLogModal = (props: RopeViewLogModalProps) => {
  const [loading, setLoading] = useState(true);
  const [entries, setEntries] = useState<RopeLog[]>([]);
  const [isRecordModalHidden, setIsRecordModalHidden] = useState(true);
  const [selectedRecord, setSelectedRecord] = useState<RopeLog | null>(null);

  const handleRecordOpenModal = record => {
    setIsRecordModalHidden(!isRecordModalHidden);
    setSelectedRecord(record);
  };

  useEffect(() => {
    setLoading(true);
    getRopeLogEntries()
      .then(data => {
        const converted = ConvertRopeLogData(data);
        setEntries(converted);
      })
      .catch(displayErrorNotification)
      .then(() => {
        setLoading(false);
      });
  }, []);

  let columns: ColumnProps<RopeLog>[] = [
    {
      title: "Message",
      dataIndex: "message",
      render: message => textOverflow(message, 130)
    },
    {
      title: "Project Information",
      dataIndex: "description"
    },
    {
      title: "File Name",
      dataIndex: "fileName"
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      render: data => (data ? formatDateTime(data) : "")
    },
    {
      title: "Created By",
      render: record => (
        <Link to={`/employees/${record.createdById}`}>{record.createdBy}</Link>
      )
    }
  ];

  return (
    <Modal
      title={"View Log"}
      visible={props.modalState}
      onCancel={props.closeModal}
      footer={null}
      width={"97vw"}
    >
      <Table
        onRow={r => {
          return {
            onClick: () => handleRecordOpenModal(r),
            style: { cursor: "pointer" }
          };
        }}
        rowKey="id"
        dataSource={entries || []}
        columns={columns}
        loading={loading}
        pagination={{ pageSize: 10, position: "top", hideOnSinglePage: true }}
      >
        <ButtonRow style={{ marginTop: "16px" }}>
          <Button onClick={props.closeModal}>Close</Button>
        </ButtonRow>
      </Table>
      {isRecordModalHidden ? null : (
        <RopeViewLogRecordModal
          modalState={true}
          closeModal={() => setIsRecordModalHidden(true)}
          record={selectedRecord || null}
        />
      )}
    </Modal>
  );
};

export default RopeViewLogModal;
